// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2prud","title":"Info_title__2BHYb","links":"Info_links__RZEFB","link":"Info_link__2wdpq","logo":"Info_logo__2mwzr"};